
export const HomePage = {

    title: "The only creative management platform for the igaming industry",
    paragraph_01: "BETEGY is the ultimate solution for creating stunning banner ads for sports betting, online casinos, and iGaming. With us, you can scale up your creative production process and launch campaigns that will attract and convert your target audience.",
    paragraph_02: "Trusted by leading brands in the industry. Experience cost and time efficiency by partnering BETEGY."

}